<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAuctionManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Auctioned Lots</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<!-- main row for all icons  -->
<div class="col-md-12 overflow-auto">
	<div class="card card-primary card-outline">
		<div class="card-body overflow-auto">
			<img v-if="lots==''" src="../images/nodata.svg">	
			<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" v-else>
      	<tbody>
        	<tr v-if="lots!=''" v-for="lot in lots" :key="lot.id">
          	<td>{{lot.name}}</td>
          	<td>{{lot.net_weight}}</td>
          	<td>{{lot.gunny_bags}}</td>
          	<td>{{lot.status}}</td>
          	<td>{{lot.sold_price}}</td>
          	<td>{{lot.seller}}</td>
          	<td>
          		<button class="btn btn-primary fa fa-info" @click="updateModal(lot)"></button>
          		<button class="btn btn-danger fa fa-cog" @click="gradeLot(lot)"></button>
          		<button class="btn btn-dark fa fa-truck" @click="statusLot(lot)"></button>
          	</td>
          </tr>				
        </tbody>
      </datatable>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getLots(pagination.prevPageUrl)"
        @next="getLots(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</section>
    
<div class="modal" tabindex="-1" role="dialog" id="updateModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
    <form @submit.prevent="updateLot" role="form">
      <div class="modal-header">
        <h5 class="modal-title">Update Lot Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div :class="['form-group', errors.name ? 'has-error' : '']">
              	<label>Name</label>
                <input type="text" name="name" class="form-control" v-model="form.name" placeholder="Enter the Name" disabled>
                <span v-if="errors.name" :class="['badge bg-danger']">Enter a valid name.</span>
              </div>
              <div :class="['form-group', errors.description ? 'has-error' : '']">
              	<label>Description</label>
                <input type="text" name="description" class="form-control" v-model="form.description" placeholder="Enter the Description" disabled>
                <span v-if="errors.description" :class="['badge bg-danger']">Enter a valid description.</span>
              </div>
              <div :class="['form-group', errors.type ? 'has-error' : '']">
								<label for="nf-type">Type</label>
								<v-select v-model="form.type" type="text" label="name" :options="types" :reduce="types => types.name" name="type" placeholder="Select Type" @input="getSubTypes" disabled></v-select>
								<span v-if="errors.type" :class="['badge bg-danger']">Please select a type.</span>
							</div>
							<div :class="['form-group', errors.subtype ? 'has-error' : '']">
								<label for="nf-subtype">Sub Type</label>
								<v-select v-model="form.subtype" type="text" label="name" :options="subtypes" :reduce="subtypes => subtypes.name" name="subtype" placeholder="Select Sub Type" disabled></v-select>
								<span v-if="errors.subtype" :class="['badge bg-danger']">Please select a sub type.</span>
							</div>
              <div :class="['form-group', errors.liter_weight ? 'has-error' : '']">
              	<label>Liter Weight</label>
                <input type="number" name="liter_weight" class="form-control" v-model="form.liter_weight" placeholder="Enter the Liter Weight" min="1" disabled>
                <span v-if="errors.liter_weight" :class="['badge bg-danger']">Enter a valid liter weight.</span>
              </div>
              <div :class="['form-group', errors.color_id ? 'has-error' : '']">
								<label for="nf-category">Color</label>
								<v-select v-model="form.color_id" type="text" label="name" :options="colors" :reduce="colors => colors.id" name="color" placeholder="Select Color" :value="colors => colors.name" disabled></v-select>
								<span v-if="errors.color_id" :class="['badge bg-danger']">Please select a color.</span>
							</div>
							<div :class="['form-group', errors.net_weight ? 'has-error' : '']">
              	<label>Net Weight</label>
                <input type="number" name="net_weight" class="form-control" v-model="form.net_weight" placeholder="Enter the Net Weight" min="1" disabled>
                <span v-if="errors.net_weight" :class="['badge bg-danger']">Enter a valid net weight.</span>
              </div>
              <div :class="['form-group', errors.currency? 'has-error' : '']">
              	<label>Currency</label>
                <input type="text" name="currency" class="form-control" v-model="form.currency" placeholder="Enter the Currency" disabled>
                <span v-if="errors.currency" :class="['badge bg-danger']">Enter a valid currency.</span>
              </div>
              <div :class="['form-group', errors.quote_price ? 'has-error' : '']">
              	<label>Quote Price</label>
                <input type="number" name="quote_price" class="form-control" v-model="form.quote_price" placeholder="Enter the Quote Price" min="1" disabled>
                <span v-if="errors.quote_price" :class="['badge bg-danger']">Enter a valid quote price.</span>
              </div>
              <div :class="['form-group', errors.control_price ? 'has-error' : '']">
              	<label>Control Price</label>
                <input type="number" name="control_price" class="form-control" v-model="form.control_price" placeholder="Enter the Control Price" min="1" disabled>
                <span v-if="errors.control_price" :class="['badge bg-danger']">Enter a valid control price.</span>
              </div>
              <div :class="['form-group', errors.seller ? 'has-error' : '']">
								<label for="nf-category">Seller</label>
								<v-select v-model="form.seller_id" type="text" label="name" :options="sellers" :reduce="sellers => sellers.id" name="seller_id" placeholder="Select Seller" :value="sellers => sellers.id" disabled></v-select>
								<span v-if="errors.seller_id" :class="['badge bg-danger']">Please select a seller.</span>
							</div>
						
      	</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
      </form>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="delModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Deliver Status</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<select v-model="status" placeholder="Select Status">
      		<option value="Sold">Sold</option>
      		<option value="Delivered">Delivered</option>
      		<option value="Returned">Returned</option>
      		<option value="Repool">Repool</option>
      		<option value="Delete">Delete</option>
      	</select>
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      	<button class="btn btn-primary" @click="change">Change</button>
      </div>
    </div>
  </div>
</div>
      <br>
      <br>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAuctionManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        
        created(){
        	this.getLots();
        	this.getColors();
        	this.getSellers();
        	this.getTypes();
        },
        
    		data(){
        	let sortOrders = {};
      		let columns = [
      			{width:'15%', label:'Number', name:'name'},
      			{width:'10%', label:'Net Weight', name:'net_weight'},
      			{width:'10%', label:'Gunny Bags', name:'gunny_bags'},
      			{width:'10%', label:'Status', name:'status'},
      			{width:'10%', label:'Sold Price', name:'sold_price'},
      			{width:'15%', label:'Seller', name:'seller'},
      			{width:'20%', label:'Manage', name:'ops'}
      		];
      		columns.forEach((column) => {
          	sortOrders[column.name]=-1;
        	});
        	return{
        		columns: columns,
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		lots: [],
         		errors: [],
         		form: new Form({
         			name: '',
        		description: '',
        		liter_weight: '',
        		color_id: '',
        		net_weight: '',
        		currency: '',
        		quote_price: '',
        		control_price: '',
        		seller_id: '',
        		id: '',
        		type: '',
        		subtype: ''
         		}),
         		
         		colors: [],
         		sellers: [],
         		types: [],
         		subtypes: [],
         		lot_id: '',
         		status: ''
         }
       },
       
       methods: {
       	configPagination(data){
      		this.pagination.last_page=data.last_page;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
  
      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},
     		
     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},
       	
       	getLots(url="/api/getSoldLots"){
       		axios.post(url, {params: this.tableData})
       		.then(response => {
       			this.lots = response.data.data.data;
       			this.configPagination(response.data.data);
       		})
       	},
       	
       	updateModal(lot){
       		this.form.fill(lot);
       		$("#updateModal").modal("show");
       	},
       	
       	getColors(){
        		axios.post("/api/getColors")
        		.then(response => {
        			this.colors = response.data;
        		})
        	},
        	
        	getSellers(){
        		axios.post("/api/getSellers")
        		.then(response => {
        			this.sellers = response.data;
        		})	
        	},
        	
        	gradeLot(lot){
        		this.$router.push("/home/auction-manager/lot-details/"+lot.id);
        	},
        	
        	getTypes(){
        		axios.post("/api/getTypes")
        		.then(response => {
        			this.types = response.data;
        		})
        	},
        	
        	getSubTypes(){
        		axios.post("/api/getSubTypes", {type: this.form.type})
        		.then(response => {
        			this.subtypes = response.data;
        		})
        	},
        	
        	statusLot(lot){
        		this.lot_id = lot.id;
        		this.status = lot.status;
        		$("#delModal").modal("show");
        	},
        	
        	change(){
        		axios.post("/api/changeLot", {id: this.lot_id, status: this.status})
        		.then(response => {
        			toast.fire({
        				type: "success",
        				title: "Status Changed"
        			});
        			this.getLots();
        		})
        		.catch(() => {
        			toast.fire({
        				type: "error",
        				title: "Failed"
        			});
        		})
        	}
       	/*,
        
        change(role, code, id){
        	switch(role){
        		case 'admin':
        			axios.post('/api/changeAdminStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		case 'auctioneer':
        			axios.post('/api/changeAuctioneerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		case 'seller':
        			axios.post('/api/changeSellerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		case 'buyer':
        			axios.post('/api/changeBuyerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		default:
        			console.log("Null");
        	}
        }*/
      }
    }
</script>
